import { render, staticRenderFns } from "./ActivitiesContainer.vue?vue&type=template&id=00a11639&scoped=true"
import script from "./ActivitiesContainer.vue?vue&type=script&lang=js"
export * from "./ActivitiesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a11639",
  null
  
)

export default component.exports